import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    Divider,
    useTheme,
    useMediaQuery,
} from '@mui/material';


import LinkViewMenuBar from '../components/menubar/LinkViewMenuBar';
import LinkingDataGrid from '../components/datagrid/LinkingDataGrid';
import {useFetch} from '../components/auth/useFetch';
import { useAbortController } from '../contexts/AbortControllerContext'
import ProjectContext from '../contexts/ProjectContext';

const sourceStyle = {
    fontSize: 10,
    color: 'grey',
    textAlign: "center",
    margin: 0,
    padding: 0
}

const selectedSourceStyle = {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'white',
    textAlign: "center",
    margin: 0,
    padding: 0,
}

export default function LinkingView(props) {
    const { getLinkSummary, transferdate, makeTour, setIsLoading } = props;

    const viewname = 'Linking'

    const { abortSimilarGroupRequests, registerController, unregisterController } = useAbortController()
    const [shotLoading, setShotLoading] = useState(false)  
    const [metadataLoading, setMetadataLoading] = useState(false)  

    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);

    const [selectedSource, setSelectedSource] = useState(null)
    const [selectionModelShots, setSelectionModelShots] = useState([])
    const [selectionModelMetadata, setSelectionModelMetadata] = useState([])

    const [sources, setSources] = useState({})
    // Shot Grid on left-hand side
    const [allShotRows, setAllShotRows] = useState([])
    const [shotRows, setShotRows] = useState([])
    const [shotColumns, setShotColumns] = useState([])
    const [sourceTabs, setSourceTabs] = useState([])
    const [sourceIndex, setSourceIndex] = useState(0);
    const fetchWithAuth = useFetch()

    const handleSourceChange = (event, newValue) => {
        setSourceIndex(newValue);
        changeMetadataSource(Object.keys(sources)[newValue])

    };

    var startColumns = [
        { field: 'thumbnail',   headerName: 'Thumbnail', renderCell:(params) => 
                                                                // <ShotRightClick>
                                                                    <Box
                                                                        width="100vw">
                                                                        <img
                                                                            alt="thumbnail"
                                                                            width="150px"
                                                                            src={`data:image/png;base64, ${params.row.thumbnail}`}
                                                                            onError={e => e.currentTarget.src = '/posters/fallbackThumbnail.png'}
                                                                        />
                                                                    </Box>
                                                                // </ShotRightClick>
                                                                    , width: 180 },
        { field: 'clipname',    headerName: 'Clipname', width: 220 },
        { field: 'scene',       headerName: 'Scene',    width: 120 },
        { field: 'take',        headerName: 'Take',     width: 90 },
        { field: 'camera',      headerName: 'Camera',   width: 90 },
        { field: 'medialabel1', headerName: 'MediaLabel1', width: 120 }]
    var baseSourceColumns = [
        { field: 'Yoyotta',     headerName: 'Yoyotta',  type: 'boolean', width: 100 },
        { field: 'SAN',         headerName: 'SAN',      type: 'boolean', width: 100 },
        { field: 'LTO',         headerName: 'LTO',      type: 'boolean', width: 100 },
        { field: 'QTake',       headerName: 'QTake',    type: 'boolean', width: 100 },
        { field: 'VFX',         headerName: 'VFX',      type: 'boolean', width: 100 },
        { field: 'Livegrade',   headerName: 'Livegrade',type: 'boolean', width: 100 },
        { field: 'ScriptPS',    headerName: 'ScriptPS', type: 'boolean', width: 100 },
        { field: 'ScriptE',     headerName: 'ScriptE',  type: 'boolean', width: 100 },
        { field: 'Silverstack', headerName: 'ScriptE',  type: 'boolean', width: 100 },
        { field: 'DCS',         headerName: 'DCS',      type: 'boolean', width: 100 }]
    var endColumns = [
        { field: 'labroll',     headerName: 'Labroll',  width: 120 },
        { field: 'episode',     headerName: 'Episode',  width: 90 },
        { field: 'starttc',     headerName: 'StartTC',  width: 120 },
        { field: 'duration',    headerName: 'Duration', width: 120 }]
    // Metadata Grid on right-hand side
    const [metadataRows, setMetadataRows] = useState([])
    const [metadataColumns, setMetadataColumns] = useState([])
    // Linking variables
    const [selectedShots, setSelectedShots] = useState([])
    const [selectedMetadata, setSelectedMetadata] = useState([])


    const newShotSelection = (rows) => {
        if (rows.length > 0){
            setSelectedShots([...rows])
        }else{
            setSelectedShots([])
        }
    }


    const newMetadataSelection = (row) => {
        if (row.length > 0){
            setSelectedMetadata(row[0])
        }else{
            setSelectedMetadata([])
        }
    }


    // LINKING FUNCTIONS
    const constructShotColumns = (sourceList) => {
        var tmpColumns = []
        tmpColumns = tmpColumns.concat(startColumns)
        sourceList.map((source) => tmpColumns.push({field: source, headerName: source, type: 'boolean', width: 100}))
        tmpColumns = tmpColumns.concat(endColumns)
        setShotColumns(tmpColumns)
    }
    const retrieveData = () => {
        retrieveShots()
        retrieveMetadata(selectedSource)
    }
    const changeMetadataSource = async (source) => {
        setMetadataRows([])
        setSelectedSource(source)
        retrieveMetadata(source)
    }
    const showAllShots = () => {
        setShotRows(allShotRows)
    }
    const showUnlinkedShots = () => {
        var tmpShotRows = []
        for (var i=0; i<allShotRows.length; i++){
            if (allShotRows[i][selectedSource] === false){
                tmpShotRows.push(allShotRows[i])
            }
        }
        setShotRows(tmpShotRows)
    }

    const autoLinkShots = () => {
        setShotLoading(true)
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/autolink?transfer_date=${transferdate}`,{
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        })
        .then(response => response.json())
        .then(() => getLinkSummary(transferdate))
        .then(() => retrieveShots())
        .catch(e => {
            console.error(e);
        })
        .finally(() => setShotLoading(false))
    }


    const runPrintTakes = () => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/runtakes/?transfer_date=${transferdate}&script=${selectedSource}`,{
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        })
        .then((res) => res.json())
        .then(() => getLinkSummary(transferdate))
        .catch(e => {
            console.error(e);
        })
    }

    // RETRIEVE DATA
    const requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: {
            'X-Project-ID': projectContext?.project_db
        }
    };


    const retrieveShots = () => {
        setShotLoading(true)

        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/linkshots?TransferDate=${transferdate}`,{
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        })
        .then(response => response.json())
        .then(result => {
            setAllShotRows(result['rows'])
            setShotRows(result['rows'])
        })
        .catch(e => {
            console.error(e);
        })
    }


    const retrieveMetadata = (source) => {
        abortSimilarGroupRequests(`${transferdate}.get.filteredmetadata`)
        const filteredMetadataController = registerController(`${transferdate}.get.filteredmetadata.${source}`)
        setIsLoading(true)
        setMetadataLoading(true)
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/filteredmetadata/?transfer_date=${transferdate}&metadata_type=${source}`,{
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
            signal: filteredMetadataController.signal
        })
        .then(response => response.json())
        .then(result => {
            setMetadataRows(result['rows'])
            setMetadataColumns(result['columns'])
        })
        .catch(e => {
            if(e.name !== 'AbortError'){
                console.error(e);
            }
        })
        .finally(() => unregisterController(filteredMetadataController, `${transferdate}.get.filteredmetadata.${source}`))
    }

    async function makeLinks(shotsLinkList){

        let data = {
            "uniqueids": shotsLinkList,
            "metadata_type": selectedSource,
            "metadata_id": selectedMetadata
        }

        let link_result = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/metadatalink/`,{
            method: 'PATCH',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        if (link_result.ok){
            // Update UI to correctly show x on newly unlinked shots
            setShotRows((prev) => {
                for(let i = 0; i < shotRows.length; i++){
                    if (shotsLinkList.includes(shotRows[i].uniqueid)){
                        prev[i][selectedSource] = true
                    }
                }
                return [...prev]
            })
            setAllShotRows((prev) => {
                for (const shot of selectedShots){
                    prev[shot][selectedSource] = selectedMetadata
                }
                return [...prev]
            })
            return shotsLinkList
        }else{
            throw new Error(`Failed to link shots ${shotsLinkList} to metadata type ${selectedSource}`)
        }
    }         


    async function removeLinks(shotsUnlinkList, shotsLinkList=[]){
        let data = {
            "uniqueids": shotsUnlinkList,
            "metadata_type": selectedSource
        }

        let unlinkResult = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/metadataunlink/`,{
            method: 'PATCH',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        if (unlinkResult.ok){
            // Update UI to correctly show x on newly unlinked shots
            setShotRows((prev) => {
                for(let i = 0; i < shotRows.length; i++){
                    if (shotRows[i].hasOwnProperty(selectedSource)){
                        if (!shotsLinkList.includes(shotRows[i].uniqueid) && shotRows[i][selectedSource] == selectedMetadata){
                            prev[i][selectedSource] = false
                        }
                        else if(shotsUnlinkList.includes(shotRows[i].uniqueid)){
                            prev[i][selectedSource] = false
                        }
                    }
                }
                return [...prev]
            })
            setAllShotRows((prev) => {
                for(let i = 0; i < allShotRows.length; i++){
                    if (allShotRows[i].hasOwnProperty(selectedSource)){
                        if (!shotsLinkList.includes(allShotRows[i].uniqueid) && allShotRows[i][selectedSource] == selectedMetadata){
                            prev[i][selectedSource] = false
                        }
                        else if(shotsUnlinkList.includes(allShotRows[i].uniqueid)){
                            prev[i][selectedSource] = false
                        }
                    }
                }
                return [...prev]
            })  
        }else{
            throw(`Failed to unlink shots ${shotsUnlinkList} from metadata type ${selectedSource}`)
        }
    }


    function clearSelection(){
        setSelectedShots([])
        setSelectedMetadata([])
        getLinkSummary(transferdate)
        setSelectionModelShots([])
        setSelectionModelMetadata([])
        setShotLoading(false)
    }


    async function linkMetadataToShot() {
        setShotLoading(true)
        // Establish new link between shot row(s) and metadata row
        // Do linking on backend
        let shotsLinkList = []
        let newLinks = []
        for (const shot of selectedShots){
            shotsLinkList.push(allShotRows[shot].uniqueid)
        }
        try{
            newLinks = await makeLinks(shotsLinkList)
        }catch (e){
            console.error(e)
            return
        }
        // AUTO UNLINK non-selected shots
        // For each row in shots, if this row is linked to the currently selected metadata, AND is not included in our new links list
        // UNLINK it
        let shotsUnlinkList = []
        for(let i = 0; i < allShotRows.length; i++){
            if(Object.keys(allShotRows[i]).indexOf(selectedSource) !== -1 && allShotRows[i][selectedSource] === selectedMetadata && !newLinks.includes(allShotRows[i]['uniqueid'])){   
                shotsUnlinkList.push(allShotRows[i]['uniqueid'])
            }
        }

        if (shotsUnlinkList.length > 0){
            try{
                await removeLinks(shotsUnlinkList, shotsLinkList)
            }
            catch(e){
                console.error(e)
            }  
        }
        clearSelection()
    } 


    async function unlinkMetadataFromShot() {
        let shotsUnlinkList = []
        for (const shot of selectedShots){
            shotsUnlinkList.push(allShotRows[shot].uniqueid)
        }
        if (selectedShots.length !== 0){
            if (!shotsUnlinkList ){
                setIsLoading(true)
                setShotLoading(true)
                for (const shot of selectedShots){
                    shotsUnlinkList.push(allShotRows[shot].uniqueid)
                }
            }
            try{
                await removeLinks(shotsUnlinkList)
            }
            catch(e){
                console.error(e)
            }
            clearSelection()
        }
    }


    const retrieveSources = () => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/sources`, requestOptions)
        .then(response => response.json())
        .then(result => {
            // Filters out items with a blank shortname for providing underlying data for tabs to map to
            const filtered_result = Object.fromEntries(
                Object.entries(result).filter(([k, v]) => v?.shortname != "" && v?.shortname != undefined)
            );

            setSources(filtered_result)
            constructShotColumns(Object.keys(filtered_result))
            let keys = Object.keys(filtered_result).sort()
            setSourceTabs(
                keys
                    .map(value => filtered_result[value]?.shortname)   
            )
        })
        .catch(e => {
            console.error(e);
        })
    }

    useEffect(()=>{
        if (sources){
            const source = Object.keys(sources)[0]
            setSelectedSource(source)
            retrieveMetadata(source)
        }
    },[sources])

    useEffect(()=>{
        if (shotLoading === false && metadataLoading === false){
            setIsLoading(false)
        }
    },[shotLoading, metadataLoading])

    useEffect(()=>{
        setShotLoading(false)
    },[shotRows])

    useEffect(()=>{
        setMetadataLoading(false)
    },[metadataRows])

    useEffect(() => {
        isAuthenticated && (() => {
            retrieveSources()
            retrieveData()
            })()
        }, [transferdate, isAuthenticated])

        useEffect(() => {
            makeTour([
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-shots',
                    content: 'All the shots for the selected transfer date appear here. Click on an item to select it.',
                    placementBeacon: 'left',
                    placement: 'right'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-metadata',
                    content: 'All the metadata that has been uploaded for this transfer date appear here. Click on an item to select it.',
                    placementBeacon: 'left',
                    placement: 'left'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-sources',
                    content: 'Switch between the sources to view all the uploaded metadata for each source. The available sources can be configured from the settings.',
                    placementBeacon: 'top'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-select-shot-metadata',
                    content: 'The identifier of the selected shot and the selected metaadata appear here.'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-link-button',
                    content: 'When both a shot and a metadata row are selected this button can be used to associate them together'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-unlink-button',
                    content: 'When a shot is selected, this button can be used to unlink any associated metadata of the selected source from the shot'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-shots-filter',
                    content: 'Use these buttons to toggle between unlinked shots of the selected source type, or show all shots. Advanced filtering can be accessed using the menu found when hovering over the table header.'
                },
                {
                    title: 'Linking Metadata',
                    target: '#linking-view-print-takes',
                    content: 'If your project makes use of a configured script source, use this button to mark the shot as a selected take.',
                    locale: {
                        next: 'Finish',
                    }
                },
            ])
        }, [])
      

    return (
        <React.Fragment>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <LinkViewMenuBar
                    autoLinkShots={autoLinkShots}
                    sources={sources}
                    selectedSource={selectedSource}
                    runPrintTakes={runPrintTakes}
                    showAllShots={showAllShots}
                    showUnlinkedShots={showUnlinkedShots}
                    allShotRows={allShotRows}
                    selectedShots={selectedShots}
                    selectedMetadata={selectedMetadata}
                    linkMetadataToShot={linkMetadataToShot}
                    unlinkMetadataFromShot={unlinkMetadataFromShot}
                    sourceIndex={sourceIndex}
                    handleSourceChange={handleSourceChange}
                    sourceTabs={sourceTabs}
                />

                {/* Viewport */}
                <Box
                    display='flex'
                    flexDirection={{xs: 'column', sm: 'row'}}
                    width='100%'
                    height='calc(100% - 47px)'
                >
                    <Box
                        id='linking-view-shots'
                        bgcolor='rgba(0,0,0,0.9)'
                        height={{xs: '50%', sm: '100%'}}
                        width={{xs: '100%', sm: '50%'}}
                        overflow='auto'
                    >
                        <Box
                            sx={{
                            width: "100%",
                            height: '100%',}}>
                            <LinkingDataGrid 
                                loading = {shotLoading}
                                columns={shotColumns}
                                rows={shotRows}    
                                selectionModel={selectionModelShots}                    
                                onSelectionModelChange={(rows) => {
                                    newShotSelection(rows)
                                    setSelectionModelShots(rows)
                                }} />
                        </Box>
                    </Box>
                    <Divider 
                        orientation={{md: "vertical", xs:"horizontal"}}
                        sx={{ 
                            borderBottomWidth: 5,
                            borderRightWidth: 5,
                            backgroundColor:"rgb(30 80 60)"
                        }}
                    />
                    <Box
                        id='linking-view-metadata'
                        bgcolor='rgba(0,0,0,0.9)'
                        height={{xs: '50%', sm: '100%'}}
                        width={{xs: '100%', sm: '50%'}}
                        overflow='auto'
                    >
                        <Box

                            sx={{
                            width: "100%",
                            height: '100%',}}>
                            <LinkingDataGrid 
                                disableMultipleSelection={true}
                                loading = {metadataLoading}
                                columns={metadataColumns}
                                rows={metadataRows}   
                                selectionModel = {selectionModelMetadata}                     
                                onSelectionModelChange={(row) => {
                                    newMetadataSelection(row)
                                    setSelectionModelMetadata(row)
                                }} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    )
}
